export default __webpack_public_path__ + "static/media/Resultados_Invitación pública_Red de Casas de Cultura_20_08_2026.9d26867e.pdf";